// extracted by mini-css-extract-plugin
module.exports = {"main":"GalleryPage_main__1USKn","container":"GalleryPage_container__365RL","one":"GalleryPage_one__3SaWR"};